import {ViewIdentifiable} from "../../models/common/ViewSettings";
import {ErrorAction, ReduxAction} from "../../models/common/ActionTypes";
import {ApiReturnType, getUserViewSettingsApiRequest} from "../../models/common/ApiReturnType";
import {AppState} from "../../reducers/RootReducer";
import {APP_CONFIG} from "../../config/GeneralConfig";
import {eventNotificationError, eventNotificationSuccess} from "../common/EventNotificationActions";
import {
    ContractorContact
} from "../../models/contractor/ContractorContact";

import {  ofType, StateObservable } from "redux-observable";
import { switchMap, map, catchError } from "rxjs/operators";
import { ajax } from "rxjs/ajax";
import { Observable, of } from 'rxjs';
import {Nullable} from "../../models/common/Nullable";
import {ContractorId} from "../../models/contractor/Contractor";
import {Identifier} from "../../models/common/Identifier";

/**
 * base API path to interact with project roles
 */
function apiPath( contractorId: number, id: Nullable<number> = null ): string {
    return APP_CONFIG.baseWeb + "contractors/"+ contractorId +"/contacts/"+ ( id !== null ? id : '');
}

/** union of all project role actions types */
export type ContractorContactActionTypes = FetchContractorContactsActionTypes

/**
 * FETCH CONTRACTOR_CONTACTS BY USER VIEW SETTINGS
 *
 * user view settings will automatically be retrieved from redux store
 */
// TYPESCRIPT REDUX ACTION TYPES
export interface FetchContractorContactsAction extends ViewIdentifiable, ContractorId, ReduxAction< typeof FETCH_CONTRACTOR_CONTACTS > {}
export interface FetchContractorContactsSuccessAction extends ContractorId, ViewIdentifiable, ReduxAction<typeof FETCH_CONTRACTOR_CONTACTS_SUCCESS > {
    payload: ApiReturnType< ContractorContact[] >
}
export interface FetchContractorContactsErrorAction extends ContractorId, ViewIdentifiable, ErrorAction< typeof FETCH_CONTRACTOR_CONTACTS_ERROR >{}

export type FetchContractorContactsActionTypes = FetchContractorContactsAction
    | FetchContractorContactsErrorAction
    | FetchContractorContactsSuccessAction

// REDUX ACTION TYPE CONSTANTS
export const FETCH_CONTRACTOR_CONTACTS = "FETCH_CONTRACTOR_CONTACTS";
export const FETCH_CONTRACTOR_CONTACTS_SUCCESS = "FETCH_CONTRACTOR_CONTACTS_SUCCESS";
export const FETCH_CONTRACTOR_CONTACTS_ERROR = "FETCH_CONTRACTOR_CONTACTS_ERROR";

// REDUX ACTION ACCESSORS FUNCTIONS
export function fetchContractorContacts(
    contractorId: Identifier< number >,
    viewIdentifier: string
) : FetchContractorContactsAction {
    return { type: FETCH_CONTRACTOR_CONTACTS, viewIdentifier, contractorId };
}
export function fetchContractorContactsSuccess(
    contractorId: Identifier<number>,
    viewIdentifier: string,
    payload: ApiReturnType< ContractorContact[] >
) : FetchContractorContactsSuccessAction
{
    return { type: FETCH_CONTRACTOR_CONTACTS_SUCCESS, viewIdentifier, payload, contractorId };
}
export function fetchContractorContactsError(
    contractorId: Identifier<number>,
    viewIdentifier: string,
    error: Error
): FetchContractorContactsErrorAction {
    return { type: FETCH_CONTRACTOR_CONTACTS_ERROR, viewIdentifier, error, contractorId };
}

// REDUX OBSERVABLE EPIC
export function fetchContractorContactsEpic(
    action$: Observable< FetchContractorContactsAction >,
    store$: StateObservable< AppState >
) {
    return action$.pipe(
        ofType( FETCH_CONTRACTOR_CONTACTS ),
        switchMap( action => {
            const request = getUserViewSettingsApiRequest(
                apiPath( action.contractorId.rawValue ),
                action.viewIdentifier,
                store$
            );

            return ajax( APP_CONFIG.getRequestObject(request.path) ).pipe(
                map( response => fetchContractorContactsSuccess(
                    action.contractorId,
                    action.viewIdentifier,
                    response.response as ApiReturnType<ContractorContact[]>
                ) ),
                catchError(error => of(
                    fetchContractorContactsError( action.contractorId, action.viewIdentifier, error),
                    eventNotificationError(error, store$, action.viewIdentifier, "fetchContractorContacts")
                ))
            );

        })
    );
}
